import { render } from "./PostSectionSelectionRelationPreviewComponent.vue?vue&type=template&id=68f0aa4a&scoped=true&ts=true"
import script from "./PostSectionSelectionRelationPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./PostSectionSelectionRelationPreviewComponent.vue?vue&type=script&lang=ts"

import "./PostSectionSelectionRelationPreviewComponent.vue?vue&type=style&index=0&id=68f0aa4a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f0aa4a"]])

export default __exports__